/**
 * Share content with the Twitter intent api.
 *
 * @url https://developer.twitter.com/en/docs/twitter-for-websites/tweet-button/guides/web-intent
 *
 * @param {string} text The text to share.
 * @param {string|null} url The url to use. If null then it uses the current page url.
 * @return {string}
 */
const twitterShare = function( text, url = null ) {

	const intent = 'https://twitter.com/intent/tweet/?';

	/**
	 * This is long, but it keeps things dynamic so that it can be edited in a
	 * single place.
	 * Just in case I ever create a stand alone Twitter account.
	 */
	const via = document.querySelector( 'meta[name="twitter:site"]' )
		.getAttribute( 'content' )
		.replace( '@', '' );
	const hashtags = 'brushninja';

	if ( null === url ) {
		url = window.location.href;
	}

	const params = {
		text,
		url,
		hashtags,
		via,
	};

	let share_url = intent;

	Object.entries( params ).forEach(
		( [ key, value ] ) => {
			share_url += key + '=' + encodeURIComponent( value ) + '&';
		}
	);

	return share_url;

};



